import React from 'react';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import {
	type Displayable,
	I18N_TYPE,
} from '@atlassian/jira-servicedesk-common/src/ui/utils/displayable/types';

type Props = {
	displayable: Displayable;
	intl: IntlShape;
};

/**
 * Allows (semi-)transparent rendering of react-intl's MessageDescriptors and
 * React nodes.
 */
function DisplayInternal({ intl: { formatMessage }, displayable }: Props) {
	if (displayable.type === I18N_TYPE) {
		const translatedMessage = formatMessage(displayable.content);
		if (translatedMessage) {
			return <span>{translatedMessage}</span>;
		}
		return null;
	}
	return <span>{displayable.content}</span>;
}

export const Display = injectIntl(DisplayInternal);
